// extracted by mini-css-extract-plugin
export var attachment = "_px-a";
export var emailContainer = "_px-4";
export var emailContentPaddedContainer = "_px-b";
export var emailHeader = "_px-6";
export var emailIframe = "_px-3";
export var emailInfoIcon = "_px-9";
export var emailShortenedSummary = "_px-e";
export var infoDropdown = "_px-0";
export var infoRowBoundedContent = "_px-d";
export var internal = "_px-5";
export var merchant = "_px-8";
export var messageInputContainer = "_px-h";
export var normal = "_px-7";
export var replyCard = "_px-f";
export var subtleButton = "_px-1";
export var subtleButtonIconContainer = "_px-2";
export var toggleViewRepliesButton = "_px-c";
export var wrappingText = "_px-g";